import {createReducer, on} from '@ngrx/store';
import {VPC} from '../../../services/api/account/vpcs/vpc.model';
import {
  clearOrganizationVPCListState,
  loadOrganizationVPCList,
  loadOrganizationVPCListFailure,
  loadOrganizationVPCListSuccess
} from './organization-account.vpc-list.actions';


export interface State {
  record: VPC[];
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const loadOrganizationVPCListReducer = createReducer(
  initialState,

  on(loadOrganizationVPCList, (state: State, action) => ({
    record: state.record,
    error: null,
    loaded: false,
    loading: true,
    parameters: action
  })),
  on(loadOrganizationVPCListSuccess, (state: State, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false
  })),
  on(loadOrganizationVPCListFailure, (state: State, action) => ({
    record: [],
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearOrganizationVPCListState, () => ({
    record: [],
    error: null,
    loaded: false,
    loading: false,
    parameters: null
  }))
);
